;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/aws/ec2/:slug\",\"regex\":\"^/aws/ec2/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/aws/elasticache/:slug\",\"regex\":\"^/aws/elasticache/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/aws/opensearch/:slug\",\"regex\":\"^/aws/opensearch/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/aws/rds/:slug\",\"regex\":\"^/aws/rds/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/aws/redshift/:slug\",\"regex\":\"^/aws/redshift/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/azure/vm/:slug\",\"regex\":\"^/azure/vm/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/gcp/:slug\",\"regex\":\"^/gcp/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/azure\"},{\"path\":\"/cache\"},{\"path\":\"/gcp\"},{\"path\":\"/opensearch\"},{\"path\":\"/rds\"},{\"path\":\"/redshift\"}],\"isrRoutes\":[\"/aws/ec2/:slug\",\"/aws/elasticache/:slug\",\"/aws/opensearch/:slug\",\"/aws/rds/:slug\",\"/aws/redshift/:slug\",\"/azure/vm/:slug\",\"/gcp/:slug\"]}";globalThis["_sentryNextJsVersion"] = "16.0.7";let importedCaptureRouterTransitionStart: (
    href: string,
    navigationType: string,
) => void | undefined;

if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
    import("@sentry/nextjs").then(
        ({ init, captureRouterTransitionStart, replayIntegration }) => {
            init({
                dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

                // Set the sample rate to 5%. With our user rate, this is still a
                // lot of useful information.
                tracesSampleRate: 0.05,

                // Turn on replays.
                integrations: [replayIntegration()],
                replaysSessionSampleRate: 0.05,
                replaysOnErrorSampleRate: 1.0,
            });
            importedCaptureRouterTransitionStart = captureRouterTransitionStart;
        },
    );
}

export const onRouterTransitionStart = (
    href: string,
    navigationType: string,
) => {
    if (importedCaptureRouterTransitionStart) {
        importedCaptureRouterTransitionStart(href, navigationType);
    }
};
